import { render, staticRenderFns } from "./SalesIncome.vue?vue&type=template&id=2ebd1146&"
import script from "./SalesIncome.vue?vue&type=script&lang=js&"
export * from "./SalesIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports